import api from './api';

const notesService = {
  list: async (params = {}) => {
    const { data } = await api.get('/notes', { params });
    return data;
  },
  get: async (noteId) => {
    const { data } = await api.get(`/notes/${noteId}`);
    return data;
  },
  create: async (payload) => {
    const { data } = await api.post('/notes', payload);
    return data;
  },
  update: async (noteId, payload) => {
    const { data } = await api.put(`/notes/${noteId}`, payload);
    return data;
  },
  remove: async (noteId, archiveOnly = false) => {
    const { data } = await api.delete(`/notes/${noteId}`, { params: { archive_only: archiveOnly } });
    return data;
  },
  linkAddress: async (noteId, addressId) => {
    const { data } = await api.post(`/notes/${noteId}/link-address`, { address_id: addressId });
    return data;
  },
  linkProject: async (noteId, projectId) => {
    const { data } = await api.post(`/notes/${noteId}/link-project`, { project_id: projectId });
    return data;
  },
  byAddress: async (addressId) => {
    const { data } = await api.get(`/notes/by-address/${addressId}`);
    return data;
  },
  byProject: async (projectId) => {
    const { data } = await api.get(`/notes/by-project/${projectId}`);
    return data;
  },
  /**
   * Lädt eine Notiz als Datei herunter (txt | docx | pdf).
   * Gibt Blob + Dateiname zurück.
   */
  exportNote: async (noteId, format = 'txt') => {
    const response = await api.get(`/notes/${noteId}/export`, {
      params: { format },
      responseType: 'blob',
    });
    // Filename aus Content-Disposition lesen
    const cd = response.headers['content-disposition'] || '';
    const match = /filename="?([^"]+)"?/.exec(cd);
    const filename = match ? match[1] : `note.${format}`;
    return { blob: response.data, filename };
  },
  /**
   * Verschickt eine Notiz per E-Mail (Anhang TXT/DOCX/PDF).
   * payload: { to: string[], cc?, bcc?, subject?, message?, format }
   */
  shareViaEmail: async (noteId, payload) => {
    const { data } = await api.post(`/notes/${noteId}/share-email`, payload);
    return data;
  },
  // === Folder-Operationen ===
  listFolders: async () => {
    const { data } = await api.get('/notes/folders/list');
    return data;
  },
  createFolder: async (payload) => {
    const { data } = await api.post('/notes/folders', payload);
    return data;
  },
  updateFolder: async (folderId, payload) => {
    const { data } = await api.put(`/notes/folders/${folderId}`, payload);
    return data;
  },
  deleteFolder: async (folderId, cascade = false) => {
    const { data } = await api.delete(`/notes/folders/${folderId}`, { params: { cascade } });
    return data;
  },
  moveNote: async (noteId, folderId) => {
    // Move = Update folder_id (null/empty = aus Ordner entfernen)
    const { data } = await api.put(`/notes/${noteId}`, { folder_id: folderId || null });
    return data;
  },
  copyNote: async (noteId, targetFolderId = null) => {
    const params = targetFolderId ? { target_folder_id: targetFolderId } : {};
    const { data } = await api.post(`/notes/${noteId}/copy`, null, { params });
    return data;
  },
};

export default notesService;
